// source: pbtypes/util/flag_util/flag_hoist.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flag_util_flag_hoist_sub_pb = require('../../../pbtypes/gen/flag_util/flag_hoist_sub_pb.js');
goog.object.extend(proto, pbtypes_gen_flag_util_flag_hoist_sub_pb);
goog.exportSymbol('proto.flag_util.flag_hoist.EncodedFlags', null, global);
goog.exportSymbol('proto.flag_util.flag_hoist.EncodedFlags.Flag', null, global);
goog.exportSymbol('proto.flag_util.flag_hoist.FlagHoistAck', null, global);
goog.exportSymbol('proto.flag_util.flag_hoist.FlagHoistCommand', null, global);
goog.exportSymbol('proto.flag_util.flag_hoist.FlagHoistCommand.CommandCase', null, global);
goog.exportSymbol('proto.flag_util.flag_hoist.NullEnum', null, global);
goog.exportSymbol('proto.flag_util.flag_hoist.NullSubscription', null, global);
goog.exportSymbol('proto.flag_util.flag_hoist.NullSubscription.VariantCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flag_util.flag_hoist.EncodedFlags = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flag_util.flag_hoist.EncodedFlags.repeatedFields_, null);
};
goog.inherits(proto.flag_util.flag_hoist.EncodedFlags, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flag_util.flag_hoist.EncodedFlags.displayName = 'proto.flag_util.flag_hoist.EncodedFlags';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flag_util.flag_hoist.EncodedFlags.Flag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flag_util.flag_hoist.EncodedFlags.Flag.displayName = 'proto.flag_util.flag_hoist.EncodedFlags.Flag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flag_util.flag_hoist.FlagHoistAck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flag_util.flag_hoist.FlagHoistAck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flag_util.flag_hoist.FlagHoistAck.displayName = 'proto.flag_util.flag_hoist.FlagHoistAck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flag_util.flag_hoist.FlagHoistCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.flag_util.flag_hoist.FlagHoistCommand.oneofGroups_);
};
goog.inherits(proto.flag_util.flag_hoist.FlagHoistCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flag_util.flag_hoist.FlagHoistCommand.displayName = 'proto.flag_util.flag_hoist.FlagHoistCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flag_util.flag_hoist.NullSubscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.flag_util.flag_hoist.NullSubscription.oneofGroups_);
};
goog.inherits(proto.flag_util.flag_hoist.NullSubscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flag_util.flag_hoist.NullSubscription.displayName = 'proto.flag_util.flag_hoist.NullSubscription';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flag_util.flag_hoist.EncodedFlags.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flag_util.flag_hoist.EncodedFlags.prototype.toObject = function(opt_includeInstance) {
  return proto.flag_util.flag_hoist.EncodedFlags.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flag_util.flag_hoist.EncodedFlags} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.EncodedFlags.toObject = function(includeInstance, msg) {
  var f, obj = {
flagsList: jspb.Message.toObjectList(msg.getFlagsList(),
    proto.flag_util.flag_hoist.EncodedFlags.Flag.toObject, includeInstance),
mastId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flag_util.flag_hoist.EncodedFlags}
 */
proto.flag_util.flag_hoist.EncodedFlags.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flag_util.flag_hoist.EncodedFlags;
  return proto.flag_util.flag_hoist.EncodedFlags.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flag_util.flag_hoist.EncodedFlags} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flag_util.flag_hoist.EncodedFlags}
 */
proto.flag_util.flag_hoist.EncodedFlags.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.flag_util.flag_hoist.EncodedFlags.Flag;
      reader.readMessage(value,proto.flag_util.flag_hoist.EncodedFlags.Flag.deserializeBinaryFromReader);
      msg.addFlags(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMastId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flag_util.flag_hoist.EncodedFlags.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flag_util.flag_hoist.EncodedFlags.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flag_util.flag_hoist.EncodedFlags} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.EncodedFlags.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.flag_util.flag_hoist.EncodedFlags.Flag.serializeBinaryToWriter
    );
  }
  f = message.getMastId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.toObject = function(opt_includeInstance) {
  return proto.flag_util.flag_hoist.EncodedFlags.Flag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flag_util.flag_hoist.EncodedFlags.Flag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
raised: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
value: jspb.Message.getFieldWithDefault(msg, 3, 0),
instance: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flag_util.flag_hoist.EncodedFlags.Flag}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flag_util.flag_hoist.EncodedFlags.Flag;
  return proto.flag_util.flag_hoist.EncodedFlags.Flag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flag_util.flag_hoist.EncodedFlags.Flag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flag_util.flag_hoist.EncodedFlags.Flag}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRaised(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flag_util.flag_hoist.EncodedFlags.Flag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flag_util.flag_hoist.EncodedFlags.Flag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRaised();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getInstance();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flag_util.flag_hoist.EncodedFlags.Flag} returns this
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool raised = 2;
 * @return {boolean}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.getRaised = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flag_util.flag_hoist.EncodedFlags.Flag} returns this
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.setRaised = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional uint32 value = 3;
 * @return {number}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.EncodedFlags.Flag} returns this
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 instance = 4;
 * @return {number}
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.getInstance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.EncodedFlags.Flag} returns this
 */
proto.flag_util.flag_hoist.EncodedFlags.Flag.prototype.setInstance = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated Flag flags = 1;
 * @return {!Array<!proto.flag_util.flag_hoist.EncodedFlags.Flag>}
 */
proto.flag_util.flag_hoist.EncodedFlags.prototype.getFlagsList = function() {
  return /** @type{!Array<!proto.flag_util.flag_hoist.EncodedFlags.Flag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.flag_util.flag_hoist.EncodedFlags.Flag, 1));
};


/**
 * @param {!Array<!proto.flag_util.flag_hoist.EncodedFlags.Flag>} value
 * @return {!proto.flag_util.flag_hoist.EncodedFlags} returns this
*/
proto.flag_util.flag_hoist.EncodedFlags.prototype.setFlagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.flag_util.flag_hoist.EncodedFlags.Flag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flag_util.flag_hoist.EncodedFlags.Flag}
 */
proto.flag_util.flag_hoist.EncodedFlags.prototype.addFlags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.flag_util.flag_hoist.EncodedFlags.Flag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flag_util.flag_hoist.EncodedFlags} returns this
 */
proto.flag_util.flag_hoist.EncodedFlags.prototype.clearFlagsList = function() {
  return this.setFlagsList([]);
};


/**
 * optional uint64 mast_id = 2;
 * @return {number}
 */
proto.flag_util.flag_hoist.EncodedFlags.prototype.getMastId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.EncodedFlags} returns this
 */
proto.flag_util.flag_hoist.EncodedFlags.prototype.setMastId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flag_util.flag_hoist.FlagHoistAck.prototype.toObject = function(opt_includeInstance) {
  return proto.flag_util.flag_hoist.FlagHoistAck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flag_util.flag_hoist.FlagHoistAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.FlagHoistAck.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
seqNumber: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flag_util.flag_hoist.FlagHoistAck}
 */
proto.flag_util.flag_hoist.FlagHoistAck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flag_util.flag_hoist.FlagHoistAck;
  return proto.flag_util.flag_hoist.FlagHoistAck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flag_util.flag_hoist.FlagHoistAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flag_util.flag_hoist.FlagHoistAck}
 */
proto.flag_util.flag_hoist.FlagHoistAck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSeqNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flag_util.flag_hoist.FlagHoistAck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flag_util.flag_hoist.FlagHoistAck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flag_util.flag_hoist.FlagHoistAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.FlagHoistAck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getSeqNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 utime = 1;
 * @return {number}
 */
proto.flag_util.flag_hoist.FlagHoistAck.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistAck} returns this
 */
proto.flag_util.flag_hoist.FlagHoistAck.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 seq_number = 2;
 * @return {number}
 */
proto.flag_util.flag_hoist.FlagHoistAck.prototype.getSeqNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistAck} returns this
 */
proto.flag_util.flag_hoist.FlagHoistAck.prototype.setSeqNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.flag_util.flag_hoist.FlagHoistCommand.oneofGroups_ = [[5,6,7]];

/**
 * @enum {number}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.CommandCase = {
  COMMAND_NOT_SET: 0,
  FLAG_UPDATE: 5,
  SUB_REQ: 6,
  ACK: 7
};

/**
 * @return {proto.flag_util.flag_hoist.FlagHoistCommand.CommandCase}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getCommandCase = function() {
  return /** @type {proto.flag_util.flag_hoist.FlagHoistCommand.CommandCase} */(jspb.Message.computeOneofCase(this, proto.flag_util.flag_hoist.FlagHoistCommand.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.flag_util.flag_hoist.FlagHoistCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flag_util.flag_hoist.FlagHoistCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.FlagHoistCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
seqNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
source: jspb.Message.getFieldWithDefault(msg, 3, ""),
needsAck: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
flagUpdate: (f = msg.getFlagUpdate()) && proto.flag_util.flag_hoist.EncodedFlags.toObject(includeInstance, f),
subReq: (f = msg.getSubReq()) && pbtypes_gen_flag_util_flag_hoist_sub_pb.FlagHoistSub.toObject(includeInstance, f),
ack: (f = msg.getAck()) && proto.flag_util.flag_hoist.FlagHoistAck.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flag_util.flag_hoist.FlagHoistCommand;
  return proto.flag_util.flag_hoist.FlagHoistCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flag_util.flag_hoist.FlagHoistCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSeqNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSource(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNeedsAck(value);
      break;
    case 5:
      var value = new proto.flag_util.flag_hoist.EncodedFlags;
      reader.readMessage(value,proto.flag_util.flag_hoist.EncodedFlags.deserializeBinaryFromReader);
      msg.setFlagUpdate(value);
      break;
    case 6:
      var value = new pbtypes_gen_flag_util_flag_hoist_sub_pb.FlagHoistSub;
      reader.readMessage(value,pbtypes_gen_flag_util_flag_hoist_sub_pb.FlagHoistSub.deserializeBinaryFromReader);
      msg.setSubReq(value);
      break;
    case 7:
      var value = new proto.flag_util.flag_hoist.FlagHoistAck;
      reader.readMessage(value,proto.flag_util.flag_hoist.FlagHoistAck.deserializeBinaryFromReader);
      msg.setAck(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flag_util.flag_hoist.FlagHoistCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flag_util.flag_hoist.FlagHoistCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.FlagHoistCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getSeqNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNeedsAck();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFlagUpdate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.flag_util.flag_hoist.EncodedFlags.serializeBinaryToWriter
    );
  }
  f = message.getSubReq();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_gen_flag_util_flag_hoist_sub_pb.FlagHoistSub.serializeBinaryToWriter
    );
  }
  f = message.getAck();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.flag_util.flag_hoist.FlagHoistAck.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 utime = 1;
 * @return {number}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 seq_number = 2;
 * @return {number}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getSeqNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.setSeqNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string source = 3;
 * @return {string}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool needs_ack = 4;
 * @return {boolean}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getNeedsAck = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.setNeedsAck = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional EncodedFlags flag_update = 5;
 * @return {?proto.flag_util.flag_hoist.EncodedFlags}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getFlagUpdate = function() {
  return /** @type{?proto.flag_util.flag_hoist.EncodedFlags} */ (
    jspb.Message.getWrapperField(this, proto.flag_util.flag_hoist.EncodedFlags, 5));
};


/**
 * @param {?proto.flag_util.flag_hoist.EncodedFlags|undefined} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
*/
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.setFlagUpdate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.flag_util.flag_hoist.FlagHoistCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.clearFlagUpdate = function() {
  return this.setFlagUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.hasFlagUpdate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional flag_util.FlagHoistSub sub_req = 6;
 * @return {?proto.flag_util.FlagHoistSub}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getSubReq = function() {
  return /** @type{?proto.flag_util.FlagHoistSub} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flag_util_flag_hoist_sub_pb.FlagHoistSub, 6));
};


/**
 * @param {?proto.flag_util.FlagHoistSub|undefined} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
*/
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.setSubReq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.flag_util.flag_hoist.FlagHoistCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.clearSubReq = function() {
  return this.setSubReq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.hasSubReq = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional FlagHoistAck ack = 7;
 * @return {?proto.flag_util.flag_hoist.FlagHoistAck}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.getAck = function() {
  return /** @type{?proto.flag_util.flag_hoist.FlagHoistAck} */ (
    jspb.Message.getWrapperField(this, proto.flag_util.flag_hoist.FlagHoistAck, 7));
};


/**
 * @param {?proto.flag_util.flag_hoist.FlagHoistAck|undefined} value
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
*/
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.setAck = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.flag_util.flag_hoist.FlagHoistCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.flag_util.flag_hoist.FlagHoistCommand} returns this
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.clearAck = function() {
  return this.setAck(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flag_util.flag_hoist.FlagHoistCommand.prototype.hasAck = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.flag_util.flag_hoist.NullSubscription.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto.flag_util.flag_hoist.NullSubscription.VariantCase = {
  VARIANT_NOT_SET: 0,
  NULL: 2
};

/**
 * @return {proto.flag_util.flag_hoist.NullSubscription.VariantCase}
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.getVariantCase = function() {
  return /** @type {proto.flag_util.flag_hoist.NullSubscription.VariantCase} */(jspb.Message.computeOneofCase(this, proto.flag_util.flag_hoist.NullSubscription.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.toObject = function(opt_includeInstance) {
  return proto.flag_util.flag_hoist.NullSubscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flag_util.flag_hoist.NullSubscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.NullSubscription.toObject = function(includeInstance, msg) {
  var f, obj = {
index: jspb.Message.getFieldWithDefault(msg, 1, 0),
pb_null: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flag_util.flag_hoist.NullSubscription}
 */
proto.flag_util.flag_hoist.NullSubscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flag_util.flag_hoist.NullSubscription;
  return proto.flag_util.flag_hoist.NullSubscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flag_util.flag_hoist.NullSubscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flag_util.flag_hoist.NullSubscription}
 */
proto.flag_util.flag_hoist.NullSubscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setIndex(value);
      break;
    case 2:
      var value = /** @type {!proto.flag_util.flag_hoist.NullEnum} */ (reader.readEnum());
      msg.setNull(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flag_util.flag_hoist.NullSubscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flag_util.flag_hoist.NullSubscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.flag_hoist.NullSubscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndex();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {!proto.flag_util.flag_hoist.NullEnum} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional uint32 index = 1;
 * @return {number}
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.flag_hoist.NullSubscription} returns this
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional NullEnum null = 2;
 * @return {!proto.flag_util.flag_hoist.NullEnum}
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.getNull = function() {
  return /** @type {!proto.flag_util.flag_hoist.NullEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flag_util.flag_hoist.NullEnum} value
 * @return {!proto.flag_util.flag_hoist.NullSubscription} returns this
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.setNull = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.flag_util.flag_hoist.NullSubscription.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.flag_util.flag_hoist.NullSubscription} returns this
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.clearNull = function() {
  return jspb.Message.setOneofField(this, 2, proto.flag_util.flag_hoist.NullSubscription.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.flag_util.flag_hoist.NullSubscription.prototype.hasNull = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.flag_util.flag_hoist.NullEnum = {
  NULL: 0
};

goog.object.extend(exports, proto.flag_util.flag_hoist);
